import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { CommercialImpacts } from '../../../viewmodels/commercial-impacts/commercial-impacts';
import { EquipmentFailureEffect } from '../../../viewmodels/equipment/equipment-failure-effect';
import { ModelFunctionsService } from '../model-functions.service';
import { I18NextPipe } from 'angular-i18next';

@Component({
  selector: 'hb-failure-effect-commercial-impact-dialog',
  templateUrl: './failure-effect-commercial-impact-dialog.component.html',
  styleUrls: ['./failure-effect-commercial-impact-dialog.component.scss'],
})
export class FailureEffectCommercialImpactDialogComponent implements OnInit {
  @Input() form: NgForm;
  @Input() isReadOnly = false;
  public title: string;
  public selectedFailureEffect: EquipmentFailureEffect;
  public onClose: Subject<CommercialImpacts> = new Subject<CommercialImpacts>();

  constructor(
    private modelFunctionsService: ModelFunctionsService,
    public bsModalRef: BsModalRef,
    private i18NextPipe: I18NextPipe
  ) {}

  ngOnInit() {
    this.title = this.i18NextPipe.transform('FailureEffectCommercialImpactDialog.CommercialImpacts');
    this.modelFunctionsService.selectedFailureEffect.subscribe(failureEffect => {
      if (failureEffect) {
        this.selectedFailureEffect = failureEffect;
      }
    });
  }

  close() {
    this.onClose.next(this.selectedFailureEffect.commercialImpacts);
    this.bsModalRef.hide();
  }
}
